import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShare1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M4.4 4.39807H2.8C2.3584 4.39807 2 4.75647 2 5.19807V13.1981C2 13.6397 2.3584 13.9981 2.8 13.9981H11.6C12.0416 13.9981 12.4 13.6397 12.4 13.1981V10.7981",
			stroke: "#636C7B",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.7998 2L13.9998 5.2L10.7998 8.4",
			stroke: "#636C7B",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.9998 5.19946H9.9998C8.2326 5.19946 6.7998 6.63226 6.7998 8.39946V9.99946",
			stroke: "#636C7B",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgShare1;
